import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminMembers, useUpdateMemberKyc, useUpdateMemberStatus } from "../../hooks/useAdmin";
import Card from "../../components/ui/Card";
import Badge from "../../components/ui/Badge";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import Select from "../../components/ui/Select";
import Avatar from "../../components/ui/Avatar";

const fmt = (n: number) => new Intl.NumberFormat("en-NG",{style:"currency",currency:"NGN", currencyDisplay:"symbol",maximumFractionDigits:0}).format(n);
const kycColor  = (k:string) => k==="verified"?"emerald":k==="reviewing"?"amber":"red";
const statColor = (s:string) => s==="active"?"emerald":s==="suspended"?"red":"amber";

export default function AdminContributionPage() {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [reason, setReason] = useState("");
  const [memid, setMemId] = useState("");

  const { data: members = [], isLoading } = useAdminMembers({ q: search || undefined, status: filter !== "all" && !filter.startsWith("kyc") ? filter : undefined, kyc: filter === "kyc-reviewing" ? "reviewing" : undefined }) as any;
  
  return (
    <div>
      <div className="flex gap-3 mb-5 flex-wrap items-end">
        <div className="flex-1 min-w-48">
          <Input label="" value={search} onChange={setSearch} placeholder="🔍 Search members…"/>
        </div>       
        
      </div>

      <Card className="p-0 overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center text-slate-400 text-sm">Loading members…</div>
        ) : (
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-slate-50">
                {["Member","Balance","Loans","Actions"].map(h => (
                  <th key={h} className="px-4 py-3 text-left text-xs font-medium text-slate-500 border-b border-slate-200">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {members.map((m: any) => (
                <tr key={m.member_id} className="border-b border-slate-100 hover:bg-slate-50 cursor-pointer"
                  onClick={() => navigate(`/admin/members/${m.member_id}`)}>
                  <td className="px-4 py-3">
                    <div className="flex gap-2.5 items-center">
                      <Avatar initials={`${m.first_name?.[0]}${m.last_name?.[0]}`} size={34}/>
                      <div>
                        <p className="text-sm font-medium text-slate-800">{m.first_name} {m.last_name}</p>
                        <p className="text-xs text-slate-400">{m.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-sm font-medium text-slate-800">{fmt(m.balance||0)}</p>
                    {m.locked_amount > 0 && <p className="text-xs text-amber-600">🔒 {fmt(m.locked_amount)} locked</p>}
                  </td>                  
                  <td className="px-4 py-3 text-sm text-slate-600">{m.loan_count||0}</td>
                  <td className="px-4 py-3" onClick={e => e.stopPropagation()}>
                    <div className="flex gap-1.5 flex-wrap">
                      <Button size="sm" variant="amber" onClick={() => navigate(`/admin/contribution/${m.member_id}`)}>Reconcile Contribution</Button>
                    </div>
                  </td>
                </tr>
              ))}
              {members.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-10 text-center text-sm text-slate-400">No members found</td></tr>
              )}
            </tbody>
          </table>
        )}

      </Card>
    </div>
  );
}
